import { useOverrides } from '../hooks/use-overrides'
import { Tabs, TabsOverrides, TabsProps } from 'baseui/tabs-motion'
import { margin, padding } from 'polished'

export const BaseTabs = ({ children, overrides, ...props }: TabsProps) => {
  return (
    <Tabs
      overrides={useOverrides<TabsOverrides>(
        {
          TabBorder: {
            style: {
              height: '1px',
            },
          },
          TabHighlight: {
            style: {
              height: '1px',
            },
          },
          TabList: {
            style: {
              ...padding('0px'),
              ...margin('0px'),
            },
          },
        },
        overrides
      )}
      {...props}
    >
      {children}
    </Tabs>
  )
}
